export interface SurveyRouteContext {
  isEformRoute: boolean;
  listRoute: "/app/surveys" | "/app/home";
  detailBackLabel: string;
}

export function isEformFlowType(flowType?: string | null): boolean {
  return String(flowType ?? "")
    .toLowerCase()
    .includes("eform");
}

export function getSurveyRouteContext(pathname: string): SurveyRouteContext {
  const isEformRoute = pathname.includes("/app/eforms");

  if (isEformRoute) {
    return {
      isEformRoute,
      listRoute: "/app/home",
      detailBackLabel: "Back to home",
    };
  }

  return {
    isEformRoute,
    listRoute: "/app/surveys",
    detailBackLabel: "Back to surveys",
  };
}

export function formTypeLabel(
  flowType?: string | null,
  forceEform = false,
): "Survey" | "eForm" {
  if (forceEform || isEformFlowType(flowType)) return "eForm";
  return "Survey";
}
